<template>
  <div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismiss-count-down="countDownChanged"
      >
        {{allertMessage}}
    </b-alert>
    <div class="camera-modal">
      <canvas ref="canvas" id="canvas"></canvas>
      <div class="image-wrapper">
        <img v-if="image" :src="image" alt="img" class="image">
        <div v-if="image" class="save-img">
          <span>
            <i @click="deleteImage" style="cursor:pointer; display:inline-block;" class="fa fa-trash" aria-hidden="true"></i>
            <i @click="saveImage" style="cursor:pointer; display:inline-block;" class="fa fa-floppy-o" aria-hidden="true"></i>
            </span>
        </div>
      </div>
      <video ref="video" class="camera-stream"/>
      <div class="camera-modal-container">
        <base-button @click="back" type="primary" nativeType='button' class="left">Back</base-button>
        <span @click="capture" class="take-picture-button mdl-button mdl-js-button mdl-button--fab mdl-button--colored">
          <i style="cursor:pointer" class="fa fa-dot-circle-o" aria-hidden="true"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from './../views/mixins/alertMixin'
export default {
  data () {
    return {
      mediaStream: null,
      blob: null,
      imgSrc: null,
      images: [],
      image: null,
      videoWidth: null,
      videoHeight: null

    }
  },
  props: {
    imagesList: {
      type: Array,
      description: 'Using to connect photo to some variable'
    }
  },
  mounted () {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return this.showAlert(2, 'This function is unavailable on your device')
    navigator.mediaDevices.getUserMedia(
      { video: {
        facingMode: 'environment',
        width: { ideal: 1920 }
      }
      })
      .then(mediaStream => {
        if (mediaStream) {
          // Getting videostream size
          this.videoHeight = mediaStream.getVideoTracks()[0].getSettings().height
          this.videoWidth = mediaStream.getVideoTracks()[0].getSettings().width
          this.mediaStream = mediaStream
          this.$refs.video.srcObject = mediaStream
          this.$refs.video.play()
        }
      })
      .catch(error => {
        console.error('getUserMedia() error:', error)
        this.showAlert(2, 'Camera not found')
      })
  },
  methods: {
    capture () {
      const canvas = document.createElement('canvas')
      canvas.setAttribute('id', 'canvas')
      let camera = this.$refs.video
      canvas.width = camera.videoWidth
      canvas.height = camera.videoHeight
      canvas.getContext('2d').drawImage(camera, 0, 0)
      this.image = canvas.toDataURL('image/jpeg', 0.8)
    },
    saveImage () {
      if (this.images.length < 3) {
        let id = '_' + Math.random().toString(36).substr(2, 9)
        this.$db.images.add({
          id: id,
          canvas: this.image
        })
          .then(() => {
            this.images.push(id)
            this.showAlert(2, 'Image has been saved')
            this.clearCanvas()
          })
          .catch(err => {
            this.showAlert(2, 'Problem with image saving')
            this.clearCanvas()
            console.log(err)
          })
      } else {
        this.showAlert(2, 'Max image quantity is 3 ')
        this.clearCanvas()
      }
    },
    deleteImage () {
      this.clearCanvas()
      this.showAlert(2, 'Image has been deleted')
    },
    clearCanvas () {
      this.image = null
      let canvas = document.getElementById('canvas')
      let ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
    },
    back () {
      this.$emit('closecamera', [this.images, this.imagesList])
    }
  },
  mixins: [alertMixin],
  destroyed () {
    let body = document.body
    body.classList.remove('overflowbody')
    if (this.mediaStream) {
      const tracks = this.mediaStream.getTracks()
      tracks.map(track => track.stop())
    }
  }
}
</script>

<style scoped>
  .camera-stream {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;
    object-fit: cover;
  }
  .camera-modal-container {
    position: absolute;
    bottom: 0;
    width: 100%;
    align-items: center;
    margin-bottom: 24px;
    text-align: center;
    padding: 0 15px;
  }
  .take-picture-button {
    text-align: center;
    display: inline-block;
    font-size: 40px;
  }
  .save-img {
    display: block;
    text-align: center;
    font-size: 35px;
    background: #5e72e4;
  }
  .save-img i {
    margin: 0 5px;
    color: #fff;
  }
  .image-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    max-width: 65%;
  }
  canvas {
    display: none;
  }
  .image {
    display: block;
    width: auto;
    max-width: 100%;
    height: auto;
  }
  .left {
    position: absolute;
    left: 15px;
    top: 50%;
    margin-top: -22px;
  }
  .right {
    position: absolute;
    right: 15px;
    top: 50%;
    margin-top: -22px;
  }
</style>
